<template>
  <div style="background-color:white">
    <el-row style="padding-top:10px">
      <el-col :span="24">
        <el-button size="small" class="btn" v-if="show.tj" type="primary" @click="handleCreate">申请报废</el-button>
        <el-button class="btn" size="small" v-if="show.sh" type="primary" @click="selectshqx">报废审核</el-button>
        <el-button class="btn" size="small" v-if="show.qr" type="primary" @click="selectqrqx">报废确认</el-button>
        <el-button size="small" type="primary" v-if="show.dctz" class="btn" @click="derive">导出列表</el-button>
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float:right!important">
          <el-form-item label="筛选单位">
            <el-cascader
            v-model="deviceInfo.companyCode" 
              :options="companyTree"
              :show-all-levels="false"
              :props="props"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item :label="lable.statue">
            <el-select v-model="deviceInfo.state" filterable clearable :placeholder="'请选择' + lable.statue"
              style="width:120px">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker v-model="deviceInfo.date" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input v-model="deviceInfo.content" auto-complete="off" placeholder="请输入搜索内容"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="findAllClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :row-key="getRowKeys"
          @selection-change="changeCheckBoxValue" 
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="scrapData" tooltip-effect="dark" 
          style="width: 100%;text-align: center" stripe>
          <el-table-column type="selection" width="55"      :reserve-selection="true"> </el-table-column>
          <el-table-column :label="lable.index" type="index"  show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="id" :label="lable.id" width="170">
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link :underline="false" @click="selectClick(scope.row)" style="color: #4095E5;text-decoration: none;">
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="glbh" :label="lable.glbh" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="zcmc" :label="lable.zcmc" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="ssdw" :label="lable.ssdw" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="scrapTime" :formatter="formateTime" :label="lable.scrapTime"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="scrapReson" :label="lable.scrapReson" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="method" :label="lable.method" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="statue" :label="lable.statue" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.statue == '1'" style="color:#4095E5" v-text="scope.row.wz"></span>
              <span v-else-if="scope.row.statue == '2'" style="color:gray" v-text="scope.row.wz"></span>
              <span v-else-if="scope.row.statue == '3'" v-text="scope.row.wz" style="color:yellowgreen"></span>
              <span v-else-if="scope.row.statue == '4'" v-text="scope.row.wz" style="color:rgb(204, 169, 13)"></span>

              <span v-else-if="scope.row.statue == '0'" style="color:red" v-text="scope.row.wz"></span>
              <span v-else-if="scope.row.statue == '1.5'" style="color:#4095E5" v-text="scope.row.wz"></span>
            </template>
          </el-table-column>
          <el-table-column :label="lable.cz" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button v-if="((scope.row.statue == '4' || scope.row.statue == '0') && show.xg)&&(scope.row.sqr==userinfo.id)"
                @click="updateClick(scope.row)" type="text" size="small">更改</el-button>
              <el-button v-if="(((scope.row.statue == '4' || scope.row.statue == '0') && show.sc)&&(scope.row.sqr==userinfo.id))||show.qjsc"
                @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
              <el-button v-if="((scope.row.statue == '1.5') && show.ch)&&(scope.row.sqr==userinfo.id)"
                @click="withdrawClick(scope.row)" type="text" size="small">撤回</el-button>
              <el-button @click="xiangqing(scope.row)" type="text" size="small">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="scrapData.length > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" style="float:right">
        </el-pagination>
      </el-col>
    </el-row>
    <!--------------------------------------------------------------------申请报废弹框--------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" title="报废申请"
      style="width:90% !important;margin-left: 10%;">
      <el-form :model="questionForm" label-position="left" label-width="100px" style="width: 90%; margin-left:5%;">
        <el-row>
          <el-col :span="12">
            <el-form-item label="资产编号">
              <el-row><el-col :span="12">
                  <el-input placeholder="请选择资产" :readonly="true" v-model="questionForm.zcbh" />
                </el-col>
                <el-col :span="4" :push="1">
                  <DC :transferValue="transferValue" :personInfo="1"></DC>
                  <!-- <el-button type="primary" disabled>选择资产</el-button> -->
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.zcmc">
              <el-input placeholder="请选择资产" :readonly="true" v-model="questionForm.zcmc" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="资产型号" style="width:90%">
              <el-input placeholder="请选择资产" v-model="questionForm.sbxh" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出厂日期">
              <el-input placeholder="请选择资产" v-model="questionForm.ccrq" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.scrapTime">
          <el-date-picker v-model="questionForm.scrapTime" value-format="yyyy-MM-dd" style="width:100%" width="100%"
            type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="lable.scrapReson">
          <el-input :placeholder="'请输入' + lable.scrapReson" v-model="questionForm.scrapReson" />
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table :data="fileData" border style="width: 100%;text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot="header" slot-scope="scope">
                <el-button type="text" @click="innerVisible = true" icon="el-icon-plus">增加
                </el-button>
              </template>
              <template slot-scope="scope">
                <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button> -->
                <el-button type="text" size="small" @click="DFile(scope.row)">删除</el-button>
                <el-button type="text" @click="yulan(scope.row)" size="small">预览</el-button>
                <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>

              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload"
          v-preventReClick>提交</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
      <el-dialog width="30%" :close-on-click-modal="false" :close-on-press-escape="false" title="添加资料"
        :visible.sync="innerVisible" append-to-body>
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="资料名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.fileDesc"></el-input>
          </el-form-item>
          <el-form-item label="选择">
            <el-upload class="upload" ref="upload" action="string" :file-list="fileList" :auto-upload="false"
              accept=".jpg,.npg,.png,.doc,.docx,.pdf,.xlsx" :http-request="uploadFile" :on-change="handleChange"
              :on-preview="handlePreview" :on-remove="handleRemove" multiple="multiple">
              <el-button slot="trigger" size="small" type="primary" @click="delFile">选取文件</el-button>
            </el-upload>
            <span>上传文件只能是jpg,png,npg,doc,docx,pdf,xlsx格式</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" v-preventReClick>上传</el-button>
            <el-button @click="innerVisible = false"> 取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>

    <!------------------------------------------------------------------------更新报废信息弹框--------------------------------===========================================----------------------->
    <el-dialog :visible.sync="dialogFormVisible1" :close-on-click-modal="false" :close-on-press-escape="false"
      title="更改信息" style="width:90% !important;margin-left: 10%;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 90%; margin-left:5%;">
        <el-row>
          <el-col :span="12">
            <el-form-item label="资产编号" style="width:90%">
              <el-input v-model="questionForm.deviceId" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.zcmc">
              <el-input v-model="questionForm.zcmc" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="资产型号" style="width:90%">
              <el-input v-model="questionForm.sbxh" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出厂日期">
              <el-input v-model="questionForm.ccrq" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.scrapTime" style="width:90%">
              <el-date-picker v-model="questionForm.scrapTime" style="width:100%" width="100%" type="date"
                value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.scrapReson">
              <el-input :placeholder="'请输入' + lable.scrapReson" v-model="questionForm.scrapReson" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="附加资料">
          <el-table :data="fileData" border style="width: 100%;text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot="header" slot-scope="scope">
                <el-button type="text" @click="innerVisible = true" icon="el-icon-plus">增加
                </el-button>
              </template>
              <template slot-scope="scope">
                <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button> -->
                <el-button type="text" size="small" @click="DFile(scope.row)">删除</el-button>
                <el-button type="text" @click="yulan(scope.row)" size="small">预览</el-button>
                <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpadte"
          v-preventReClick>提交</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
      <el-dialog width="30%" title="添加资料" :close-on-click-modal="false" :close-on-press-escape="false"
        :visible.sync="innerVisible" append-to-body>
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="资料名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.fileDesc"></el-input>
          </el-form-item>
          <el-form-item label="选择">
            <el-upload class="upload" ref="upload" action="string" :file-list="fileList" :auto-upload="false"
              accept=".jpg,.npg,.png,.doc,.docx,.pdf,.xlsx" :http-request="uploadFile" :on-change="handleChange"
              :on-preview="handlePreview" :on-remove="handleRemove" multiple="multiple">
              <el-button slot="trigger" size="small" type="primary" @click="delFile">选取文件</el-button>
            </el-upload>
            <span>上传文件只能是jpg,png,npg,doc,docx,pdf,xlsx格式</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" v-preventReClick>上传</el-button>
            <el-button @click="innerVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
    <!------------------------------------------------------------------------报废详情弹框------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible2" :close-on-click-modal="false" :close-on-press-escape="false"
      title="报废详情" style="width:90% !important;margin-left: 10%;">
      <el-form :model="questionForm" ref="dataForm" size="mini" label-position="left" label-width="100px"
        style="width: 90%; margin-left:5%;">
        <el-row>
          <el-col :span="12">
            <el-form-item label="资产编号" prop="correctAnswer" style="width:90%">
              <el-input v-model="questionForm.deviceId" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.zcmc">
              <el-input v-model="questionForm.zcmc" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="资产型号" style="width:90%">
              <el-input v-model="questionForm.sbxh" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出厂日期">
              <el-input v-model="questionForm.ccrq" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width:90%">
              <el-input v-model="questionForm.userName" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请日期">
              <el-input v-model="questionForm.sqrq" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.companyName" style="width:90%">
              <el-input v-model="questionForm.companyName" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核结果">
              <el-input v-model="questionForm.result" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.scrapReson">
          <el-input v-model="questionForm.scrapReson" :readonly="true" />
        </el-form-item>
        <el-form-item label="审核意见">
          <el-input type="textarea" :rows="2" :readonly="true" v-model="questionForm.ssyj" />
        </el-form-item>
        <el-form-item :label="lable.method">
          <el-input :readonly="true" v-model="questionForm.method" />
        </el-form-item>
        <el-form-item label="处置日期">
          <el-input :readonly="true" v-model="questionForm.handleTime" />
        </el-form-item>
        <el-tabs v-model="activeName">
          <el-tab-pane label="业务流程信息" name="first">
            <el-table :data="tableData" :border="true" style="width: 90%;margin-left: 20PX;text-align: center" size="mini"
              max-height="235px" :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
              :cell-style="{ textAlign: 'center' }">
              <el-table-column label="序号" type="index" show-overflow-tooltip >
              </el-table-column>
              <el-table-column prop="createTime" label="时间" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="nodeName" label="事件" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="workflowResult" label="审批结果" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="bz" label="审核意见" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="ssdw" label="单位" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="userId" label="操作人" show-overflow-tooltip>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="附加资料" name="second">
            <el-table :data="fileData" :border="true" max-height="235px"
              style="width: 90%;margin-left: 20PX;text-align: center" size="mini"
              :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
              <el-table-column label="序号" type="index" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
              </el-table-column>

              <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="150px">
                <template slot-scope="scope">
                  <el-button @click="yulan(scope.row)" type="text" size="small">预览</el-button>
                  <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>

        </el-tabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false" type="primary" v-preventReClick>确认</el-button>
      </div>
    </el-dialog>

    <!--------------------------------------------------------------------报废审核弹框--------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible3" :close-on-click-modal="false" :close-on-press-escape="false"
      title="报废审核" style="width:90% !important;margin-left: 200px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
        style="width: 90%; margin-left:5%;">

        <el-row>
          <el-col :span="12">
            <el-form-item label="资产编号" style="width:90%">
              <el-input v-model="questionForm.deviceId" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.zcmc">
              <el-input v-model="questionForm.zcmc" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="资产型号" style="width:90%">
              <el-input v-model="questionForm.sbxh" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.scrapTime">
              <el-input v-model="questionForm.scrapTime" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.scrapReson" style="width:90%">
              <el-input v-model="questionForm.scrapReson" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.userName">
              <el-input v-model="questionForm.userName" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="申请日期" style="width:90%">
              <el-input v-model="questionForm.sqrq" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.companyName">
              <el-input v-model="questionForm.companyName" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="业务流程信息">
          <el-table :data="tableData" :border="true" style="width: 100%;text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" >
            </el-table-column>
            <el-table-column prop="createTime" label="时间" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="nodeName" label="事件" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="workflowResult" label="审批结果" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="bz" label="审核意见" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ssdw" label="单位" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="userId" label="操作人" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </el-form-item>
        <!-- <el-form-item label="审核结果">
          <el-radio-group style="width:100%" v-model="questionForm.sout">
            <el-radio label="0">通过</el-radio>
            <el-radio label="1">驳回</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="审核意见">
          <el-input type="textarea" :rows="2" placeholder="请输入审核意见" v-model="questionForm.ssyj" />
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table :data="fileData" :border="true" style="width: 100%;text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip >
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot-scope="scope">
                <el-button @click="yulan(scope.row)" type="text" size="small">预览</el-button>
                <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" type="primary" @click="submitUpdate" v-preventReClick>通过</el-button>
        <el-button style="margin-left: 10px" type="danger" @click="noAuidt" v-preventReClick>驳回</el-button>
        <el-button @click="dialogFormVisible3 = false">取消</el-button>
      </div>
    </el-dialog>

    <!--------------------------------------------------------------------报废确认--------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible4" :close-on-click-modal="false" :close-on-press-escape="false"
      title="报废确认" style="width:100% !important;margin-left: 80px;">
      <el-form :model="questionForm" ref="dataForm" size="mini" label-position="left" label-width="100px"
        style="width: 90%; margin-left:5%;">
        <el-row>
          <el-col :span="12">
            <el-form-item label="资产编号" prop="correctAnswer" style="width:90%">
              <el-input v-model="questionForm.deviceId" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.zcmc">
              <el-input v-model="questionForm.zcmc" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="资产型号" style="width:90%">
              <el-input v-model="questionForm.sbxh" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出厂日期">
              <el-input v-model="questionForm.ccrq" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width:90%">
              <el-input v-model="questionForm.userName" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请日期">
              <el-input v-model="questionForm.sqrq" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.companyName" style="width:90%">
              <el-input v-model="questionForm.companyName" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核结果">
              <el-input v-model="questionForm.result" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.scrapReson">
          <el-input v-model="questionForm.scrapReson" :readonly="true" />
        </el-form-item>
        <el-form-item label="审核意见">
          <el-input type="textarea" :rows="2" :readonly="true" v-model="questionForm.ssyj" />
        </el-form-item>
        <!-- <el-form-item label="确认结果">
          <el-radio-group v-model="questionForm.qr">
            <el-radio label="0">报废</el-radio>
            <el-radio label="1">未报废</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item :label="lable.method">
          <el-input :placeholder="'请输入' + lable.method" v-model="questionForm.method" />
        </el-form-item>
        <el-form-item label="处置日期">
          <el-date-picker v-model="questionForm.handleTime" style="width:100%" width="100%" type="date"
            value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table :data="fileData" :border="true" style="width: 100%;text-align: center" size="mini" max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }" :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip >
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="createTime" label="上传日期" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot-scope="scope">
                <el-button @click="yulan(scope.row)" type="text" size="small">预览</el-button>
                <el-button type="text" size="small" @click="downloading(scope.row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" type="primary" @click="notarize" v-preventReClick>确定</el-button>
        <el-button style="margin-left: 10px" type="danger" @click="noNotarize" v-preventReClick>驳回</el-button>

        <el-button @click="dialogFormVisible4 = false">取消</el-button>
      </div>
    </el-dialog>
     <!-- 添加显示购物车按钮，如果复选框有选中让显示，否则不显示 -->
     <div
      style="
        position: fixed;
        top: 12.5%;
        left: 33%;
        height: 50px;
        width: 50px;
        color: #4095e5;
        font-size: 20px;
      "
      @click="checkBoxdialog = true"
      v-if="checkBoxData.length > 0"
    >
      <!-- <i class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></i> -->
      <el-badge :value="checkBoxNumber">
        <img
          src="../../../static/img/selects.png"
          style="width: 70%; height: 70%; font-size: 40px"
        />
        <!-- <span class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></span> -->
      </el-badge>
    </div>
     <!-- 显示购物车列表 -->
     <el-dialog
      title="已选择设备"
      :visible.sync="checkBoxdialog"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-button
        type="primary"
        size="mini"
        @click="removeAllCheckbox"
        style="margin-top: -30px; float: left"
        >清空内容</el-button
      >
      <el-table
        :data="checkBoxData"
        v-if="checkBoxNumber > 0"
        :header-cell-style="{ background: '#eff3f6' }"
        style="padding-top: 5px"
      >
      <el-table-column :label="lable.index" type="index"  show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="id" :label="lable.id" >
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link :underline="false" @click="selectClick(scope.row)" style="color: #4095E5;text-decoration: none;">
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="glbh" :label="lable.glbh" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="zcmc" :label="lable.zcmc" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="ssdw" :label="lable.ssdw" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="scrapTime" :formatter="formateTime" :label="lable.scrapTime"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="scrapReson" :label="lable.scrapReson" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="method" :label="lable.method" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="statue" :label="lable.statue" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.statue == '1'" style="color:#4095E5" v-text="scope.row.wz"></span>
              <span v-else-if="scope.row.statue == '2'" style="color:gray" v-text="scope.row.wz"></span>
              <span v-else-if="scope.row.statue == '3'" v-text="scope.row.wz" style="color:yellowgreen"></span>
              <span v-else-if="scope.row.statue == '4'" v-text="scope.row.wz" style="color:rgb(204, 169, 13)"></span>

              <span v-else-if="scope.row.statue == '0'" style="color:red" v-text="scope.row.wz"></span>
              <span v-else-if="scope.row.statue == '1.5'" style="color:#4095E5" v-text="scope.row.wz"></span>
            </template>
          </el-table-column>
        <el-table-column label="操作" style="text-decoration: none">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="removeThisData(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px" width="63%">
      <FilePreview ref="filePreview" />
    </el-dialog>
  </div>
</template>

<script>
import {
  findAllDeviceScrap,
  upload,
  findByIdFile,
  delByIdFile,
  findByIdWorkflow,
  addDeviceScrap,
  delDeviceScrap,
  updDeviceScrap,
  findByIdScrap,
  cxbfspqx,
  selectAllstatus,
  auditScrap,
  cxbfqrqx,
  findByUserIdCompanyTree,
  excelBFExport,
  notarizeScrap,
  findByModule,
  withdrawDeviceScrap
} from "../../api/api";
import DeviceComponent from "../../components/common/DeviceComponent.vue";
import FilePreview from '../../components/preview/FilePreview.vue'


export default {
  name: "Scrap",
  components: {
    "FilePreview": FilePreview,
    "DC": DeviceComponent,
  },
  data() {
    return {
      deviceInfo: {
        date: [],
        content: "",
        state: ""
      },
      companyTree:[],
      props: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
      },
      activeName: [],
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      scrapData: [],
      options: [],
      show: {
        dctz: false,
        sc: false,
        xg: false,
        tj: false,
        sh: false,
        qr: false,
        ch: false,
        qjsc:false
      },
      lable: {},
      multipleSelection: [],
      form: {
        name: "",
        fileDesc: ""
      },
      checkBoxdialog: false,
      checkBoxData: [],
      checkBoxNumber: 0,
      activeName: 'first',
      fileData: [],
      fileList: [],
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      dialogFormVisible4: false,
      innerVisible: false,
      docxdialog: false,
      previewTitle: '',
      questionForm: {
      },
      tableData: [],
      userinfo:{},
    };
  },
  methods: {
    getRowKeys(row) {
      return row.id;
    },
    //清空所有内容
    removeAllCheckbox() {
      this.checkBoxData = [];
      this.checkBoxNumber = this.checkBoxData.length;
      this.$refs.multipleTable.clearSelection(); //清除所有选中复选框
      this.checkBoxdialog = false;
    },
    //获取复选框选中数据
    changeCheckBoxValue(val) {
      console.log(val);
      this.checkBoxData = val;
      this.checkBoxNumber = this.checkBoxData.length;
    },
    //移除一条选中内容
    removeThisData(row) {
      let newCheckBoxData = [];
      for (var i = 0; i < this.checkBoxData.length; i++) {
        if (this.checkBoxData[i].id != row.id) {
          // debugger
          newCheckBoxData.push(this.checkBoxData[i]);
        }
      }
      this.checkBoxData = newCheckBoxData;
      if (this.checkBoxData.length > 0) {
        this.$refs.multipleTable.store.states.selection.map((item, index) => {
          if (item.id === row.id) {
            this.$refs.multipleTable.store.states.selection.splice(index, 1);
          }
        });
      } else {
        this.$refs.multipleTable.clearSelection(); //清除所有选中复选框
        this.checkBoxdialog = false;
      }
      this.checkBoxNumber = this.checkBoxData.length;
    },
    //撤回 
    withdrawClick(row) {
      this.$confirm('此操作将撤回该条信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var userinfo = JSON.parse(localStorage.getItem("user"))
        var map = {
          id: row.id,
          userId: userinfo.userId
        }
        withdrawDeviceScrap(map).then(datas => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.findAll();
            this.$message({
              message: "撤回成功",
              type: "success"
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      })
    },
    downloading(scop) {
      // debugger
      this.downloadUtil.downloadFile(scop.path, scop.name);
    },
    notarize() {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      this.questionForm.userId = userinfo.userId
      this.questionForm.qr = 0;
      notarizeScrap(this.questionForm).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.$message({
            message: "确认成功",
            type: "success"
          });
          this.findAll();
          this.dialogFormVisible4 = false
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    noNotarize() {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      this.questionForm.qr = 1;
      this.questionForm.userId = userinfo.userId
      notarizeScrap(this.questionForm).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.$message({
            message: "驳回成功",
            type: "success"
          });
          this.findAll();
          this.dialogFormVisible4 = false
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    selectqrqx() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.error("只能选择一条记录"); // .....失败信息
      } else if (currentSelect.length == 1) {
        if (currentSelect[0].statue == 2) {
          var userinfo = JSON.parse(localStorage.getItem("user"))
          var map = {
            id: currentSelect[0].id,
            userId: userinfo.userId
          }
          cxbfqrqx(map).then(datas => {
            // debugger
            let { status, message } = datas;
            if (status == 400) {
              this.$message({
                message: message,
                type: "error"
              });
            } else if (status == 200) {
              this.questionForm = {};
              this.questionForm = currentSelect[0];
              this.$set(this.questionForm, `scrapTime`, this.timeUtil.timeFormat(new Date()))
              this.findByIdfile(currentSelect[0].id)
              this.dialogFormVisible4 = true;
            } else {
              this.$message({
                message: "请求错误",
                type: "error"
              });
            }
          });
        } else {
          this.$message.error("该信息不属于待确认状态"); // .....失败信息
        }
      } else {
        this.$message.error("请选择设备"); // .....失败信息
      }
    },
    submitUpdate() {
      this.questionForm.sout = 0
      this.audit(this.questionForm);
    },
    noAuidt() {
      this.questionForm.sout = 1
      this.audit(this.questionForm);
    },
    //审核
    audit(row) {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      var map = row
      map.userId = userinfo.userId
      auditScrap(map).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.dialogFormVisible3 = false;
          this.findAll();
          this.$message({
            message: "审核成功",
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    //查询是否符号权限
    selectshqx() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.error("只能选择一条记录"); // .....失败信息
      } else if (currentSelect.length == 1) {
        if ((currentSelect[0].statue == 1) | (currentSelect[0].statue == 1.5)) {
          currentSelect[0].statue = 1;
          var userinfo = JSON.parse(localStorage.getItem("user"))
          var map = {
            id: currentSelect[0].id,
            userId: userinfo.userId
          }
          cxbfspqx(map).then(datas => {
            // debugger
            let { status, message } = datas;
            if (status == 400) {
              this.$message({
                message: message,
                type: "error"
              });
            } else if (status == 200) {
              this.findByIdWork(currentSelect[0].id);
              this.questionForm = {};
              this.questionForm = currentSelect[0];
              this.findByIdfile(currentSelect[0].id)
              this.dialogFormVisible3 = true;
            } else {
              this.$message({
                message: "请求错误",
                type: "error"
              });
            }
          });
        } else {
          this.$message.error("该信息不属于待审批状态"); // .....失败信息
        }
      } else {
        this.$message.error("请选择设备"); // .....失败信息
      }
    },
    yulan(row) {
      if (row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpg' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'png' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpeg') {
        this.previewTitle = "图片预览"
      } else {
        this.previewTitle = "文件预览"
      }
      this.docxdialog = true
      this.$nextTick(() => {
        this.$refs.filePreview.showView(row.path)
      })
      // this.downloadUtil.preview(row.path)
    },
    findAllClick(){
      this.pageIndex=1;
      this.findAll()
    },
    derive() {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content, 
        state: this.deviceInfo.state,
        userId: userinfo.userId
      };
      if (this.checkBoxData.length > 0) {
        map["ids"] = this.checkBoxData.map((item) => item.id).join();
      }else{
        map["ids"] = ""
      }
      excelBFExport(map).then(datas => {
        const blob = new Blob([datas])
        const dlink = document.createElement('a')
        if ('download' in document.createElement('a')) { // 非IE下载
          const dlink = document.createElement('a')
          dlink.download = "报废台账.xlsx"
          dlink.style.display = 'none'
          dlink.href = URL.createObjectURL(blob)
          document.body.appendChild(dlink)
          dlink.click()
          URL.revokeObjectURL(dlink.href) // 释放URL 对象
          document.body.removeChild(dlink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, "报废台账.xlsx")
        }
      })
      // BFWord().then(datas => {
      //     const blob = new Blob([datas])
      //     const dlink = document.createElement('a')
      //     if ('download' in document.createElement('a')) { // 非IE下载
      //       const dlink = document.createElement('a')
      //       dlink.download = "报废申请.docx"
      //       dlink.style.display = 'none'
      //       dlink.href = URL.createObjectURL(blob)
      //       document.body.appendChild(dlink)
      //       dlink.click()
      //       URL.revokeObjectURL(dlink.href) // 释放URL 对象
      //       document.body.removeChild(dlink)
      //     } else { // IE10+下载
      //       navigator.msSaveBlob(blob, "报废申请.docx")
      //     }
      //   })
    },
    transferValue(outData) {
      this.$set(this.questionForm, 'zcmc', outData.zcmc);
      this.$set(this.questionForm, 'zcbh', outData.zcbh);
      this.$set(this.questionForm, 'sbxh', outData.sbxh);
      this.$set(this.questionForm, 'ccrq', outData.ccrq);
      this.$set(this.questionForm, 'deviceId', outData.id);
      this.$set(this.questionForm, 'glbh', outData.glbh);
    },
    updateClick(row) {
      this.questionForm = row;
      this.dialogFormVisible1 = true;
      this.findByIdfile(row.id);
    },
    //标记 跳转
    selectClick(row) {
      if (row.statue == 0 && this.show.xg) {
        this.questionForm = row;
        this.dialogFormVisible1 = true;
        this.findByIdfile(row.id);
      } else if ((row.statue == 1 | row.statue == 1.5) && this.show.sh) {
        row.statue = 1;
        var userinfo = JSON.parse(localStorage.getItem("user"))
        var map = {
          id: row.id,
          userId: userinfo.userId
        }
        cxbfspqx(map).then(datas => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.xiangqing(row);
          } else if (status == 200) {
            this.findByIdWork(row.id);
            this.questionForm = {};
            this.questionForm = row;
            this.findByIdfile(row.id)
            this.dialogFormVisible3 = true;
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      } else if (row.statue == 2 && this.show.qr) {
        var userinfo = JSON.parse(localStorage.getItem("user"))
        var map = {
          id: row.id,
          userId: userinfo.userId
        }
        cxbfqrqx(map).then(datas => {              // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.xiangqing(row);
          } else if (status == 200) {
            this.questionForm = {};
            this.questionForm = row;
            this.$set(this.questionForm, `scrapTime`, this.timeUtil.timeFormat(new Date()))
            this.findByIdfile(row.id)
            this.dialogFormVisible4 = true;
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      } else {
        this.xiangqing(row);
      }
    },
    xiangqing(row) {
      var id = row.id;
      findByIdScrap(id).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.questionForm = data;
        }
      });
      this.findByIdfile(id);
      this.findByIdWork(id);
      this.dialogFormVisible2 = true;
    },

    handleClick(row) {
      this.$confirm('此操作将永久删除该条信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var userinfo = JSON.parse(localStorage.getItem("user"))
        var map = {
          id: row.id,
          userId: userinfo.userId
        }
        delDeviceScrap(map).then(datas => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.findAll();
            this.$message({
              message: "删除成功",
              type: "success"
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      })
    },
    cancel() {
      this.dialogFormVisible1 = false;
      this.findAll()
    },
    //删除检定附件信息
    DFile(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delByIdFile(row.id).then(datas => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            // var id = "bf" + this.questionForm.deviceId;
            this.findByIdfile(this.questionForm.id);
            this.$message({
              message: message,
              type: "success"
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      })
    },
    //更改报废信息
    submitUpadte() {
      if (this.questionForm.statue == 1.5) {
        this.questionForm.statue = 1
      }
      var userinfo = JSON.parse(localStorage.getItem("user"))
      this.questionForm.userId = userinfo.userId
      // this.questionForm.fileIds = a1;
      updDeviceScrap(this.questionForm).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.dialogFormVisible1 = false;
          this.findAll();
          this.$message({
            message: data,
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    //根据id查找文件
    findByIdfile(id) {
      findByIdFile(id).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.fileData = data;
          // debugger
        }
      });
    },

    //根据id查找业务流程信息
    findByIdWork(row) {
      findByIdWorkflow(row).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.tableData = data;
          // debugger
        }
      });
    },
    //文件上传
    onSubmit() {
      if (this.fileList[0] == null) {
        this.$message.error("请选择上传的文件"); // .....失败信息
      } else {
        var formData = new FormData();
        formData.append("file", this.fileList[0].raw); //拿到存在fileList的文件存放到formData中
        //下面数据是我自己设置的数据,可自行添加数据到formData(使用键值对方式存储)
        formData.append("name", this.form.name);
        formData.append("fileDesc", this.form.fileDesc);
        formData.append("number", this.questionForm.id);
        var userinfo = JSON.parse(localStorage.getItem("user"))
        formData.append("userId", userinfo.userId)
        upload(formData).then(datas => {
          // debugger
          let { status, message, data } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.fileData.push(data);
            // this.findByIdfile(this.questionForm.id);
            this.$message({
              message: '上传成功',
              type: "success"
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
          this.innerVisible = false;
          this.form.fileDesc = "";
          this.form.name = "";
          this.fileList = [];
        });
      }
    },

    //添加报废信息
    submitUpload() {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      this.questionForm.userId = userinfo.userId
      addDeviceScrap(this.questionForm).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.dialogFormVisible = false;
          this.findAll();
          this.$message({
            message: "添加成功",
            type: "success"
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },

    //点击上传文件触发的额外事件,清空fileList
    delFile() {
      this.fileList = [];
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    //自定义上传文件
    uploadFile(file) {
      this.formData.append("file", file.file);
    },
    //删除文件
    handleRemove(file, fileList) {
    },
    // 点击文件
    handlePreview(file) {
    },

    //申请报废弹窗 设置测试数据
    handleCreate() {
      let id = "BF" + +new Date();
      this.questionForm = {
        id: id
      };
      this.$set(this.questionForm, `scrapTime`, this.timeUtil.timeFormat(new Date()))
      this.findByIdfile(id);
      this.dialogFormVisible = true;
    },

    //查找所有维保信息
    findAll() {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        state: this.deviceInfo.state,
        userId: userinfo.userId,
        companyCode: null
      };
      if(this.deviceInfo.companyCode!=null){
        map.companyCode=this.deviceInfo.companyCode[this.deviceInfo.companyCode.length-1] 
      }
      findAllDeviceScrap(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) { this.data = [] } else { this.data = data; }
          this.scrapData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = this.data.length;
        } else if (status == 400) {
          this.$message.warning(message)
        }
      });
    },
    findAllType() {
      selectAllstatus().then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].statusType == "报废管理") {
              this.options.push({ name: data[i].statusName, id: data[i].statue })
            }
          }
        }
      });
    },
    //分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.scrapData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.scrapData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    findLable() {
      findByModule("报废管理").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
    // 格式化时间显示到日期
    formateTime(row) {
      let nowData = new Date(row.scrapTime)
      let year = nowData.getFullYear();
      let month = (nowData.getMonth() + 1).toString().padStart(2, '0');
      let date = nowData.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${date}`;
    },
    getCompanyTree() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var  companyCode='';
      if (userinfo.userRole == 1 || (userinfo.fjqx != null && (userinfo.fjqx.indexOf ("3")!=-1||userinfo.fjqx.indexOf ("4")!=-1))) {
        companyCode="-1"
      }else{
        companyCode=userinfo.companyCode
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.companyTree = this.getTreeData(data);
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].zcompany);
        }
      }
      return data;
    },
  },
  created() {
    this.getCompanyTree();
    this.findLable();
    this.findAll();
    this.findAllType();
    var userinfo = JSON.parse(localStorage.getItem("user"))
    this.userinfo=userinfo;
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "110") {
        this.show.dctz = true;
      }
      if (i == "109") {
        this.show.sc = true;
      }
      if (i == "108") {
        this.show.xg = true;
      }
      if (i == "107") {
        this.show.tj = true;
      }
      if (i == "111") {
        this.show.sh = true;
      }
      if (i == "112") {
        this.show.qr = true;
      }
      if (i == '197') {
        this.show.ch = true
      }
      if (i == '201') {
        this.show.qjsc = true
      }
    })
  }
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}
</style> >



// WEBPACK FOOTER //
// src/views/scrap/Scrap.vue